/**
 * Application constants
 */

/**
 * Maximum number of players allowed in a session
 * System-wide limit that applies to all sessions
 */
export const MAX_SESSION_PLAYERS = 20;
